import React, { useState } from 'react';
import { Form, Modal, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import 'react-datepicker/dist/react-datepicker.css';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useDispatch, useSelector } from 'react-redux';
import { alertAdded, alertRemoved } from '../../store/alert';
import config from '../../config/config';
import signupAPI from '../../api/ADMIN/signupAPI';

function Signup(props) {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [code, setCode] = useState("");
  const [openPopup, setopenPopup] = useState(props.openPopup);
  const handleClose = () => setopenPopup(false);
  const alert = useSelector((state) => state.alert);
  const type = config.CLIENT;
  const navigate = useNavigate();
  const validateForm = () => {
    return name.length > 0 && email.length > 0 && phone.length > 0 && password.length > 0 && confirmPassword.length > 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm() && password === confirmPassword) {
      signupAPI({
        type,
        name,
        email,
        phone,
        password,
      }).then((res) => {
        console.log(res);
        if (res && res.success) {
          setopenPopup(true);
          // history.push("/home");
        } else {
          let msg = res ? (res.data ? res.data.msg : res.message) : "Unknown Error";
          if (typeof msg === 'object') {
            msg = msg.message || JSON.stringify(msg);
          }
          dispatch(alertAdded({ variant: "danger", message: msg }));
        }
      });
    } else if (password !== confirmPassword) {
      dispatch(
        alertAdded({
          variant: "warning",
          message: "Password and Confirm Password should match.",
        })
      );
    }
  };

  const handleOTPSubmit = (event) => {
    event.preventDefault();
    if (validateForm() && password === confirmPassword) {
      signupAPI({
        type,
        name,
        email,
        phone,
        password,
        otp: code,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          setopenPopup(false);
          alertAdded({
            variant: "success",
            message: "Registered Successfully",
          });
          navigate("/client/login");
        } else {
          dispatch(alertAdded({ variant: "danger", message: res.message || "OTP Verification Failed" }));
        }
      });
    } else if (password !== confirmPassword) {
      alertAdded({
        variant: "warning",
        message: "Password and Confirm Password should match.",
      });
    }
  };

  return (
    <div>
      <div
        id='signupform'
        onClick={() => {
          dispatch(alertRemoved());
        }}
      >
        <div id='right-signup'>
          <img
            style={{ height: "100%", width: "100%", margin: "40% auto" }}
            src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
            alt={"logistic_logo"}
          />
        </div>
        <div id='left-signup'>
          <Form onSubmit={handleSubmit} className='signup'>
            <div>
              <h2 id='headerTitle'>Register</h2>
              <Alert show={alert.show} variant={alert.variant}>
                {alert.message}
              </Alert>
              <div className='row'>
                <label>Name</label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className='row'>
                <label>Phone Number</label>
                <PhoneInput
                  // placeholder="Enter phone number"
                  defaultCountry='IN'
                  value={phone}
                  style={{ width: "85%" }}
                  onChange={setPhone}
                />
              </div>
              <div className='row'>
                <label>Email</label>
                <input
                  // placeholder="Enter your Last Name"

                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className='row'>
                <label>Password</label>
                <input
                  // placeholder="Enter your Last Name"
                  type='password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className='row'>
                <label>Confirm Password</label>
                <input
                  // placeholder="Enter your Last Name"
                  type='password'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>

              <div id='button' class='row'>
                <button
                  style={{ width: "45%", fontSize: "15px" }}
                  type='submit'
                  disabled={!validateForm()}
                >
                  Get OTP
                </button>
              </div>
              {openPopup && (
                <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "white", padding: "2rem", border: "1px solid #ccc", borderRadius: "8px", zIndex: 1000, boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
                  <h3>Enter OTP</h3>
                  <div className='row' style={{ margin: "1rem 0" }}>
                    <input
                      type='text'
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      placeholder="Enter OTP"
                      style={{ padding: "0.5rem", width: "100%" }}
                    />
                  </div>
                  <div className='row'>
                    <label style={{ color: "black", marginBottom: "1rem" }}>
                      OTP sent to phone number {phone}
                    </label>
                  </div>
                  <div className='d-flex gap-2 justify-content-center'>
                    <button
                      className="btn btn-primary"
                      onClick={handleOTPSubmit}
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
              {/* <Button block size='lg' type='submit' disabled={!validateForm()}>
                Submit
              </Button> */}
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Signup;
